// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conciliation-view {
  display: grid;
  gap: var(--ui-space-4);
}

.conciliation-hero,
.conciliation-panel {
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-xl);
  background: linear-gradient(150deg, rgba(255, 255, 255, 0.97), rgba(246, 251, 254, 0.94));
  box-shadow: var(--ui-elevation-1);
}

.conciliation-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(250px, 330px);
  gap: var(--ui-space-5);
  padding: clamp(1.1rem, 2vw, 1.6rem);
  background:
    radial-gradient(circle at 92% 12%, rgba(20, 114, 79, 0.12), transparent 34%),
    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(241, 249, 253, 0.96));
}

.conciliation-hero h2,
.conciliation-panel h3 {
  margin: 0;
  color: var(--ui-text);
}

.conciliation-hero h2 {
  font-size: clamp(1.55rem, 2.2vw, 2.1rem);
}

.conciliation-mode-card {
  display: grid;
  align-content: center;
  gap: 0.55rem;
  padding: 1rem;
  border-radius: var(--ui-radius-lg);
  border: 1px solid rgba(29, 90, 124, 0.14);
  background: rgba(255, 255, 255, 0.72);
}

.conciliation-mode-card strong {
  font-size: 1rem;
}

.conciliation-mode-card small,
.conciliation-preview-note,
.conciliation-panel-head p,
.conciliation-actions p {
  color: var(--ui-text-soft);
  line-height: 1.45;
}

.conciliation-layout {
  display: grid;
  grid-template-columns: minmax(420px, 1.65fr) minmax(300px, 0.9fr);
  gap: var(--ui-space-4);
  align-items: start;
}

.conciliation-main,
.conciliation-side {
  display: grid;
  gap: var(--ui-space-4);
}

.conciliation-panel {
  padding: clamp(1rem, 1.8vw, 1.35rem);
}

.conciliation-panel-head {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: var(--ui-space-4);
}

.conciliation-panel-head.compact {
  margin-bottom: var(--ui-space-3);
}

.conciliation-panel-head p:not(.conciliation-kicker) {
  margin: 0.35rem 0 0;
  font-size: 0.88rem;
}

.conciliation-kicker {
  margin: 0 0 0.35rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: var(--ui-accent);
}

.conciliation-status-pill {
  display: inline-flex;
  align-items: center;
  min-height: 1.85rem;
  padding: 0.3rem 0.65rem;
  border-radius: var(--ui-radius-pill);
  border: 1px solid rgba(29, 90, 124, 0.16);
  font-size: 0.72rem;
  font-weight: 700;
  white-space: nowrap;
  color: var(--ui-accent-strong);
  background: rgba(29, 90, 124, 0.07);
}

.conciliation-status-pill.available,
.conciliation-status-pill.ready {
  border-color: rgba(20, 114, 79, 0.22);
  color: var(--ui-success);
  background: rgba(20, 114, 79, 0.08);
}

.conciliation-status-pill.planned {
  color: var(--ui-warning);
  border-color: rgba(149, 109, 21, 0.2);
  background: rgba(149, 109, 21, 0.08);
}

.conciliation-context-grid {
  display: grid;
  gap: var(--ui-space-3);
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.conciliation-context-grid label {
  display: grid;
  gap: 0.42rem;
  color: var(--ui-text-soft);
  font-size: 0.78rem;
  font-weight: 700;
}

.conciliation-context-grid select,
.conciliation-context-grid input {
  min-height: 2.7rem;
  padding: 0.65rem 0.7rem;
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  color: var(--ui-text);
  background: var(--ui-surface);
}

.conciliation-upload-grid {
  display: grid;
  gap: var(--ui-space-3);
}

.conciliation-upload-card {
  display: grid;
  gap: 0.55rem;
  padding: 0.95rem 1rem;
  border: 1px dashed rgba(42, 78, 102, 0.28);
  border-radius: var(--ui-radius-lg);
  background: rgba(255, 255, 255, 0.7);
  cursor: pointer;
}

.conciliation-upload-card.selected {
  border-style: solid;
  border-color: rgba(20, 114, 79, 0.26);
  background: rgba(240, 251, 246, 0.82);
}

.conciliation-upload-title {
  display: flex;
  gap: 0.8rem;
  justify-content: space-between;
  align-items: center;
}

.conciliation-upload-title span {
  padding: 0.2rem 0.48rem;
  border-radius: var(--ui-radius-pill);
  font-size: 0.68rem;
  font-weight: 700;
}

.conciliation-upload-title .required {
  color: var(--ui-accent-strong);
  background: rgba(29, 90, 124, 0.09);
}

.conciliation-upload-title .optional {
  color: var(--ui-text-soft);
  background: rgba(42, 78, 102, 0.07);
}

.conciliation-upload-card p,
.conciliation-upload-card input,
.conciliation-file-summary {
  margin: 0;
  font-size: 0.84rem;
  color: var(--ui-text-soft);
}

.conciliation-upload-card input {
  width: 100%;
}

.conciliation-file-summary {
  font-weight: 600;
  color: var(--ui-text);
  overflow-wrap: anywhere;
}

.conciliation-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--ui-space-3);
  margin-top: var(--ui-space-4);
  padding-top: var(--ui-space-3);
  border-top: 1px solid var(--ui-border);
}

.conciliation-actions p {
  margin: 0;
  font-size: 0.86rem;
}

.conciliation-actions .btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.conciliation-period {
  margin: 0.35rem 0 var(--ui-space-4);
  font-weight: 700;
  color: var(--ui-accent);
}

.conciliation-step-list {
  list-style: none;
  display: grid;
  gap: var(--ui-space-3);
  margin: 0;
  padding: 0;
}

.conciliation-step-list li {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.75rem;
}

.conciliation-step-list strong,
.conciliation-review-item strong {
  display: block;
  color: var(--ui-text);
  font-size: 0.9rem;
}

.conciliation-step-list small,
.conciliation-review-item small {
  display: block;
  color: var(--ui-text-soft);
  font-size: 0.78rem;
  line-height: 1.4;
}

.conciliation-step-dot {
  width: 0.72rem;
  height: 0.72rem;
  border-radius: 50%;
  margin-top: 0.26rem;
  background: rgba(149, 109, 21, 0.35);
}

.conciliation-step-dot.available {
  background: var(--ui-success);
}

.conciliation-review-list {
  display: grid;
  gap: 0.65rem;
}

.conciliation-preview-note {
  margin: 0 0 var(--ui-space-3);
  font-size: 0.84rem;
}

.conciliation-review-item {
  display: grid;
  gap: 0.25rem;
  padding: 0.78rem 0.85rem;
  border: 1px solid rgba(42, 78, 102, 0.12);
  border-radius: var(--ui-radius-md);
  background: rgba(255, 255, 255, 0.72);
}

.conciliation-review-item span {
  margin-top: 0.25rem;
  color: var(--ui-accent);
  font-size: 0.72rem;
  font-weight: 700;
}

:root[data-theme='dark'] .conciliation-hero,
:root[data-theme='dark'] .conciliation-panel {
  color: var(--ui-text);
  background: linear-gradient(150deg, rgba(17, 35, 47, 0.96), rgba(13, 28, 39, 0.94));
  border-color: var(--ui-border);
}

:root[data-theme='dark'] .conciliation-mode-card,
:root[data-theme='dark'] .conciliation-upload-card,
:root[data-theme='dark'] .conciliation-review-item {
  background: rgba(9, 22, 32, 0.72);
  border-color: rgba(120, 163, 193, 0.28);
}

:root[data-theme='dark'] .conciliation-upload-card.selected {
  background: rgba(13, 42, 33, 0.72);
  border-color: rgba(79, 209, 152, 0.36);
}

:root[data-theme='dark'] .conciliation-context-grid select,
:root[data-theme='dark'] .conciliation-context-grid input {
  background: rgba(8, 20, 29, 0.92);
  border-color: rgba(120, 163, 193, 0.36);
  color: var(--ui-text);
}

@media (max-width: 1080px) {
  .conciliation-layout,
  .conciliation-hero {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 720px) {
  .conciliation-panel-head,
  .conciliation-actions {
    flex-direction: column;
    align-items: flex-start;
  }

  .conciliation-context-grid {
    grid-template-columns: 1fr;
  }

  .conciliation-actions .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/views-conciliacion.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,kCAAkC;EAClC,kCAAkC;EAClC,yFAAyF;EACzF,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,sBAAsB;EACtB,mCAAmC;EACnC;;iFAE+E;AACjF;;AAEA;;EAEE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iEAAiE;EACjE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;;EAEE,qCAAqC;EACrC,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,kCAAkC;EAClC,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,0CAA0C;EAC1C,kCAAkC;EAClC,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;;;EAGE,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,yCAAyC;EACzC,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,mFAAmF;EACnF,8BAA8B;AAChC;;AAEA;;;EAGE,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".conciliation-view {\n  display: grid;\n  gap: var(--ui-space-4);\n}\n\n.conciliation-hero,\n.conciliation-panel {\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-xl);\n  background: linear-gradient(150deg, rgba(255, 255, 255, 0.97), rgba(246, 251, 254, 0.94));\n  box-shadow: var(--ui-elevation-1);\n}\n\n.conciliation-hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(250px, 330px);\n  gap: var(--ui-space-5);\n  padding: clamp(1.1rem, 2vw, 1.6rem);\n  background:\n    radial-gradient(circle at 92% 12%, rgba(20, 114, 79, 0.12), transparent 34%),\n    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(241, 249, 253, 0.96));\n}\n\n.conciliation-hero h2,\n.conciliation-panel h3 {\n  margin: 0;\n  color: var(--ui-text);\n}\n\n.conciliation-hero h2 {\n  font-size: clamp(1.55rem, 2.2vw, 2.1rem);\n}\n\n.conciliation-mode-card {\n  display: grid;\n  align-content: center;\n  gap: 0.55rem;\n  padding: 1rem;\n  border-radius: var(--ui-radius-lg);\n  border: 1px solid rgba(29, 90, 124, 0.14);\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.conciliation-mode-card strong {\n  font-size: 1rem;\n}\n\n.conciliation-mode-card small,\n.conciliation-preview-note,\n.conciliation-panel-head p,\n.conciliation-actions p {\n  color: var(--ui-text-soft);\n  line-height: 1.45;\n}\n\n.conciliation-layout {\n  display: grid;\n  grid-template-columns: minmax(420px, 1.65fr) minmax(300px, 0.9fr);\n  gap: var(--ui-space-4);\n  align-items: start;\n}\n\n.conciliation-main,\n.conciliation-side {\n  display: grid;\n  gap: var(--ui-space-4);\n}\n\n.conciliation-panel {\n  padding: clamp(1rem, 1.8vw, 1.35rem);\n}\n\n.conciliation-panel-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n  margin-bottom: var(--ui-space-4);\n}\n\n.conciliation-panel-head.compact {\n  margin-bottom: var(--ui-space-3);\n}\n\n.conciliation-panel-head p:not(.conciliation-kicker) {\n  margin: 0.35rem 0 0;\n  font-size: 0.88rem;\n}\n\n.conciliation-kicker {\n  margin: 0 0 0.35rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  color: var(--ui-accent);\n}\n\n.conciliation-status-pill {\n  display: inline-flex;\n  align-items: center;\n  min-height: 1.85rem;\n  padding: 0.3rem 0.65rem;\n  border-radius: var(--ui-radius-pill);\n  border: 1px solid rgba(29, 90, 124, 0.16);\n  font-size: 0.72rem;\n  font-weight: 700;\n  white-space: nowrap;\n  color: var(--ui-accent-strong);\n  background: rgba(29, 90, 124, 0.07);\n}\n\n.conciliation-status-pill.available,\n.conciliation-status-pill.ready {\n  border-color: rgba(20, 114, 79, 0.22);\n  color: var(--ui-success);\n  background: rgba(20, 114, 79, 0.08);\n}\n\n.conciliation-status-pill.planned {\n  color: var(--ui-warning);\n  border-color: rgba(149, 109, 21, 0.2);\n  background: rgba(149, 109, 21, 0.08);\n}\n\n.conciliation-context-grid {\n  display: grid;\n  gap: var(--ui-space-3);\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.conciliation-context-grid label {\n  display: grid;\n  gap: 0.42rem;\n  color: var(--ui-text-soft);\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.conciliation-context-grid select,\n.conciliation-context-grid input {\n  min-height: 2.7rem;\n  padding: 0.65rem 0.7rem;\n  border: 1px solid var(--ui-border);\n  border-radius: var(--ui-radius-md);\n  color: var(--ui-text);\n  background: var(--ui-surface);\n}\n\n.conciliation-upload-grid {\n  display: grid;\n  gap: var(--ui-space-3);\n}\n\n.conciliation-upload-card {\n  display: grid;\n  gap: 0.55rem;\n  padding: 0.95rem 1rem;\n  border: 1px dashed rgba(42, 78, 102, 0.28);\n  border-radius: var(--ui-radius-lg);\n  background: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n}\n\n.conciliation-upload-card.selected {\n  border-style: solid;\n  border-color: rgba(20, 114, 79, 0.26);\n  background: rgba(240, 251, 246, 0.82);\n}\n\n.conciliation-upload-title {\n  display: flex;\n  gap: 0.8rem;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.conciliation-upload-title span {\n  padding: 0.2rem 0.48rem;\n  border-radius: var(--ui-radius-pill);\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\n.conciliation-upload-title .required {\n  color: var(--ui-accent-strong);\n  background: rgba(29, 90, 124, 0.09);\n}\n\n.conciliation-upload-title .optional {\n  color: var(--ui-text-soft);\n  background: rgba(42, 78, 102, 0.07);\n}\n\n.conciliation-upload-card p,\n.conciliation-upload-card input,\n.conciliation-file-summary {\n  margin: 0;\n  font-size: 0.84rem;\n  color: var(--ui-text-soft);\n}\n\n.conciliation-upload-card input {\n  width: 100%;\n}\n\n.conciliation-file-summary {\n  font-weight: 600;\n  color: var(--ui-text);\n  overflow-wrap: anywhere;\n}\n\n.conciliation-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--ui-space-3);\n  margin-top: var(--ui-space-4);\n  padding-top: var(--ui-space-3);\n  border-top: 1px solid var(--ui-border);\n}\n\n.conciliation-actions p {\n  margin: 0;\n  font-size: 0.86rem;\n}\n\n.conciliation-actions .btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.conciliation-period {\n  margin: 0.35rem 0 var(--ui-space-4);\n  font-weight: 700;\n  color: var(--ui-accent);\n}\n\n.conciliation-step-list {\n  list-style: none;\n  display: grid;\n  gap: var(--ui-space-3);\n  margin: 0;\n  padding: 0;\n}\n\n.conciliation-step-list li {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.75rem;\n}\n\n.conciliation-step-list strong,\n.conciliation-review-item strong {\n  display: block;\n  color: var(--ui-text);\n  font-size: 0.9rem;\n}\n\n.conciliation-step-list small,\n.conciliation-review-item small {\n  display: block;\n  color: var(--ui-text-soft);\n  font-size: 0.78rem;\n  line-height: 1.4;\n}\n\n.conciliation-step-dot {\n  width: 0.72rem;\n  height: 0.72rem;\n  border-radius: 50%;\n  margin-top: 0.26rem;\n  background: rgba(149, 109, 21, 0.35);\n}\n\n.conciliation-step-dot.available {\n  background: var(--ui-success);\n}\n\n.conciliation-review-list {\n  display: grid;\n  gap: 0.65rem;\n}\n\n.conciliation-preview-note {\n  margin: 0 0 var(--ui-space-3);\n  font-size: 0.84rem;\n}\n\n.conciliation-review-item {\n  display: grid;\n  gap: 0.25rem;\n  padding: 0.78rem 0.85rem;\n  border: 1px solid rgba(42, 78, 102, 0.12);\n  border-radius: var(--ui-radius-md);\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.conciliation-review-item span {\n  margin-top: 0.25rem;\n  color: var(--ui-accent);\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n:root[data-theme='dark'] .conciliation-hero,\n:root[data-theme='dark'] .conciliation-panel {\n  color: var(--ui-text);\n  background: linear-gradient(150deg, rgba(17, 35, 47, 0.96), rgba(13, 28, 39, 0.94));\n  border-color: var(--ui-border);\n}\n\n:root[data-theme='dark'] .conciliation-mode-card,\n:root[data-theme='dark'] .conciliation-upload-card,\n:root[data-theme='dark'] .conciliation-review-item {\n  background: rgba(9, 22, 32, 0.72);\n  border-color: rgba(120, 163, 193, 0.28);\n}\n\n:root[data-theme='dark'] .conciliation-upload-card.selected {\n  background: rgba(13, 42, 33, 0.72);\n  border-color: rgba(79, 209, 152, 0.36);\n}\n\n:root[data-theme='dark'] .conciliation-context-grid select,\n:root[data-theme='dark'] .conciliation-context-grid input {\n  background: rgba(8, 20, 29, 0.92);\n  border-color: rgba(120, 163, 193, 0.36);\n  color: var(--ui-text);\n}\n\n@media (max-width: 1080px) {\n  .conciliation-layout,\n  .conciliation-hero {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 720px) {\n  .conciliation-panel-head,\n  .conciliation-actions {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .conciliation-context-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .conciliation-actions .btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
